import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { getMultiPolygonBounds, multiPolygonWithHolesToGeoJSON } from "@nova/calculate-geospatial"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import store from "integrations/redux/store"
import { getViewport, getViewportBounds } from "features/map/GlobalViewState"
import { createExternalStore } from "@nova/toolkit-pure-hooks"
import { CachedNotam } from "../../types"
import { getMinNotamShapeArea } from "../../zoomLod"
import { SupportedRegions } from "@nova/constants"

const MAX_NOTAM_ENTRY_COUNT = 4000

const { set, prune, useAll, useItems, useItem } = createExternalStore<CachedNotam>({
    maxEntries: MAX_NOTAM_ENTRY_COUNT,
})
export const useNotamCache = useAll
export const useNotams = useItems
export const useNotam = useItem

export const fetchAndCacheNotams = ({ abortController }: { abortController: AbortController }) => {
    const orgId = selectActiveWorkspaceId()(store.getState())
    if (!orgId) return

    const bounds = getViewportBounds()
    const zoom = getViewport().zoom
    const minArea = getMinNotamShapeArea(zoom)
    fetchApiGateway("get /org/:orgId/get-notam", {
        params: { orgId },
        query: `minLat=${bounds.minLat}&maxLat=${bounds.maxLat}&minLng=${bounds.minLng}&maxLng=${bounds.maxLng}&minArea=${minArea}`,
        region: SupportedRegions.Canada,
        signal: abortController.signal,
    })
        .then((res) => {
            const returnedIds: string[] = []
            res.notams.forEach((notam) => {
                const id = `${notam.id}`
                returnedIds.push(id)
                const geometry = multiPolygonWithHolesToGeoJSON(notam.geometry)
                set(id, {
                    type: "notam",
                    feature: { type: "Feature", id, geometry, properties: notam.properties },
                    properties: notam.properties,
                    bbox: getMultiPolygonBounds(notam.geometry),
                    area: notam.properties.area,
                })
            })
            prune(returnedIds)
        })
        .catch((err) => {
            if (err?.name !== "AbortError") {
                console.warn("[notam] fetch failed:", err)
            }
        })
}
